/* eslint-disable */

<template>
    <v-form ref="registryForm" v-model="valid" class="ma-0 pa-0">
    <v-container width="100%">
        <v-row no-gutters>
            <v-col cols="12" md="6">
                <v-text-field dense outlined
                    v-model="c_data.name"
                    label="ragione sociale*"
                    :rules="[rules.nameRules, rules.mandatory]"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="possible_match.length>0 && !(possible_match.length==1 && possible_match[0].id == o_data._id)">
                <div class="font-italic mx-2">Possibili duplicazioni</div>
                <ul><span v-for="client of possible_match" :key="client.id">
                    <li 
                        v-if="client.id!=c_data._id"
                        class="caption">
                        {{client.value.name}} - PIVA: {{client.value.piva}}
                    </li>
                </span>
                </ul>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" class="text-subtitle-1">
                Dati fatturazione
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6" >
                <v-text-field dense outlined
                    label="partiva iva*"
                    v-model="c_data.piva"
                    :rules="[rules.piva, rules.mandatory]"
                ></v-text-field>
            </v-col>
            <v-col cols="6" class="pl-2">
                <v-text-field dense outlined
                    label="codice fiscale*"
                    v-model="c_data.fiscal_code"
                    :rules="[rules.fiscal_code, rules.mandatory]"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row v-if="!is_organism" no-gutters>
            <v-col cols="6">
                <v-text-field dense outlined
                    label="PEC"
                    v-model="c_data.pec"
                    :rules="[rules.emailRules]"
                ></v-text-field>
            </v-col>
            <v-col cols="6" class="pl-2">
                <v-text-field dense outlined
                    label="codice univoco"
                    v-model="c_data.unique_code"
                    :rules="[rules.nameRules]"
                ></v-text-field>
            </v-col>
        </v-row> 
        <v-row v-if="!is_organism" no-gutters>
            <v-col cols="12" class="d-flex justify-space-between">
                <v-autocomplete outlined dense
                    v-if="locations.length>0"
                    label="seleziona sede legale*"
                    v-model="c_data.registered_office"
                    :items="locations"
                    item-text="value.name"
                    item-value="_id"
                    cache-items
                    clearable
                    :rules="[rules.mandatory]"
                    class="mr-4"
                />
                <v-checkbox dense outline hide-details label="partner di fatturazione/intermediario" v-model="c_data.is_partner" ></v-checkbox>
            </v-col>
        </v-row>
    </v-container>
    </v-form>
</template>

<script>
// import _ from 'lodash'

import {f_rules} from '../../utils/commonUtils'
import {searchByText, searchDesign} from "../../utils/dbUtility"

export default {
    props: {
        o_data: {
            type: Object,
            required: true
        },
        is_organism: {
            type: Boolean,
            required: false,
            default: false
        },
        locations: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            rules: f_rules,
            valid: false,
            c_data: {},
            search_match: {name:'', piva:''},
            possible_match: [],
            view: 'clients',
            //unique_piva: v => this.isDuplicatedPIVA(v),
        }
    },
    created(){
        this.debouncedClient = _.debounce(function(){
            //console.log('debouncedClient')
            this.searchClient()
        },300)
    },
    mounted() {
        this.c_data = _.cloneDeep(this.o_data)
        this.view = this.is_organism ? 'organisms' : 'clients/searchByText'
        this.possible_match = []
    },
    methods: { 
        getData() {
            return this.c_data
        },
        async isValid() {
            let dup = await this.isDuplicatedPIVA(this.c_data.piva)
            //console.log("isValid",dup)
            return this.valid && !dup
        },
        resetValidation(){
            this.$refs.registryForm.resetValidation()
        },
        async searchClient(){
            // serch by name - ispettori interni
            this.possible_match = []
            this.c_loading = true
            if (!!this.search_match.piva && this.search_match.piva.trim().length > 2){
                let res = await searchByText(this.$store.state.$pouch, 'registry', this.view, this.search_match.piva)
                if (res != null) {
                    this.possible_match = res
                }
            } 
            if (!!this.search_match.name && this.search_match.name.trim().length > 2){
                let res = await searchByText(this.$store.state.$pouch, 'registry', this.view, this.search_match.name)
                if (res != null) {
                    this.possible_match = _.unionBy(this.possible_match, res, 'id')
                }
                
            }
            this.c_loading = false
            
        },
        async isDuplicatedPIVA(piva) {
            if (piva && piva.length == 11){
                let current_id = this.o_data._id
                let clients = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['piva', piva], false)
                let match = clients.filter(client => { if (client.id != current_id) return client })
                let isMatch = match && match.length>0
                return isMatch
            }
            return true
        },
        
    },
    watch: {
        'c_data.name': {
            handler() {
                if (this.c_data.name && this.c_data.name.trim()!='') {
                    this.search_match.name = this.c_data.name
                    this.debouncedClient()
                }
            }
        },
        'c_data.piva': {
            handler() {
                if (this.c_data.piva && this.c_data.piva.trim()!='') {
                    this.search_match.piva = this.c_data.piva
                    this.debouncedClient()
                }
            }
        },
        valid() {
            this.$emit('valid_registry', this.valid)
        },
        o_data() {
            this.c_data = _.cloneDeep(this.o_data)
        }
    }
}
</script>